import { CreateContactData } from '@/helpers/hubspot/types';
import { ReplaceVirtuallyFormState } from '../constants';
import { Dispatch } from 'react';
import { ReplaceVirtuallyFormActionMap } from '../reducer';
import { ContactInfoStepActions } from '../steps/ContactInfoStep/state';

export const getContact = async (
	state: ReplaceVirtuallyFormState,
	dispatch: Dispatch<ReplaceVirtuallyFormActionMap>,
) => {
	const createContactBody: CreateContactData = {
		email: state.email,
		firstName: state.firstName,
		lastName: state.lastName,
		phone: state.phone,
	};

	const response = await fetch('/api/hubspot/contact', {
		method: 'POST',
		body: JSON.stringify(createContactBody),
	});
	const data = await response.json();

	if (data.hubspotErrorCode === 'INVALID_EMAIL') {
		throw new Error(
			'Invalid email. Please check the email address provided and try again.',
		);
	}

	if (!data || !data.id) {
		throw new Error('Failed to create HubSpot contact');
	}

	const hubspotContactId = data.id;

	dispatch({
		type: ContactInfoStepActions.SET_HUBSPOT_CONTACT_ID,
		payload: hubspotContactId,
	});

	return hubspotContactId;
};
